export class AuthenticationError extends Error {
  public readonly statusCode: number | undefined

  constructor (message: string, statusCode?: number) {
    super(message)
    this.name = 'AuthenticationError'
    this.statusCode = statusCode
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
